// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alternate-medication-view ods-icon {
  margin: 0.2rem 0.2rem 0 0;
}
.alternate-medication-view .covered {
  display: inline-flex;
}
.alternate-medication-view .covered ods-icon {
  color: var(--green-3);
}
.alternate-medication-view .notcovered {
  display: inline-flex;
}
.alternate-medication-view .notcovered ods-icon {
  color: var(--red-3);
}
.alternate-medication-view .drugname {
  color: var(--brand-50);
  text-decoration: underline;
}
.alternate-medication-view .alternate-medication-desktop-view {
  padding: 0 2.2rem 0.5rem 2.2rem;
  background: #DADFE3;
}
.alternate-medication-view .alternate-medication-desktop-view .alternate-medication-table {
  width: 100%;
  min-width: 1165px;
  display: grid;
  grid-template-columns: 5.5fr 2fr 2fr 2fr 2.5fr;
  grid-template-rows: auto;
  grid-gap: 0;
  font-size: 0.875rem;
}
.alternate-medication-view .alternate-medication-desktop-view .alternate-medication-table.alternate-medication-table-rows {
  margin: 0 0.5rem;
}
.alternate-medication-view .alternate-medication-desktop-view .alternate-medication-table > div {
  padding: 0.5rem;
}
.alternate-medication-view .alternate-medication-desktop-view .alternate-medication-table > div.alternate-medication-table__header {
  font-weight: 700;
  font-size: 0.875rem;
  border-bottom: 1px solid var(--grey-30);
  border-right: 0;
  border-left: 0;
  padding: 1rem;
  background-repeat: no-repeat;
}
.alternate-medication-view .view-more-alternate-medications {
  margin: 1rem;
}
.alternate-medication-view .view-more-alternate-medications a {
  color: var(--brand-50);
  font-weight: 700;
  font-size: 0.9rem;
}
.alternate-medication-view .alternate-medication-mobile-view {
  margin: 0 1rem 0.5rem 1rem;
  border-top: 1px solid var(--neutral-40);
  line-height: 2rem;
}
.alternate-medication-view .alternate-medication-mobile-view .title {
  font-weight: 700;
  padding: 1rem 0;
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row {
  background: var(--grey-20);
  padding: 1rem 0.5rem;
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row:nth-child(odd) {
  background: var(--weight);
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row dl {
  display: flex;
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row dl dt {
  flex: 1;
  font-weight: 700;
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row dl dd {
  flex: 0.6;
}
.alternate-medication-view .alternate-medication-mobile-view .alternate-medication-mobile-row dl ods-icon {
  margin-top: 0.5rem;
}
.alternate-medication-view .alternate-medication-mobile-view .view-more-alternate-medications {
  margin: 0.5rem;
  border-top: 1px solid var(--neutral-20);
  border-bottom: 1px solid var(--neutral-20);
  padding: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/medication/components/alternate-medication-table/alternate-medication-table.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,qBAAA;AACN;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,mBAAA;AACN;AAEE;EACE,sBAAA;EACA,0BAAA;AAAJ;AAEE;EACE,+BAAA;EACA,mBAAA;AAAJ;AACI;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8CAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;AACN;AAAM;EACE,gBAAA;AAER;AAAM;EACE,eAAA;AAER;AADQ;EACE,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,4BAAA;AAGV;AAEE;EACE,YAAA;AAAJ;AACI;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;AACN;AAEE;EACE,0BAAA;EACA,uCAAA;EACA,iBAAA;AAAJ;AACI;EACE,gBAAA;EACA,eAAA;AACN;AACI;EACE,0BAAA;EACA,oBAAA;AACN;AAAM;EACE,yBAAA;AAER;AAAM;EACE,aAAA;AAER;AADQ;EACE,OAAA;EACA,gBAAA;AAGV;AADQ;EACE,SAAA;AAGV;AADQ;EACI,kBAAA;AAGZ;AAEI;EACI,cAAA;EACA,uCAAA;EACA,0CAAA;EACA,eAAA;AAAR","sourcesContent":[".alternate-medication-view {\n  ods-icon {\n    margin: 0.2rem 0.2rem 0 0;\n  }\n  .covered {\n    display: inline-flex;\n    ods-icon {\n      color: var(--green-3);\n    }\n  }\n  .notcovered {\n    display: inline-flex;\n    ods-icon {\n      color: var(--red-3);\n    }\n  }\n  .drugname {\n    color: var(--brand-50);\n    text-decoration: underline;\n  }\n  .alternate-medication-desktop-view {\n    padding: 0 2.2rem 0.5rem 2.2rem;\n    background: #DADFE3;\n    .alternate-medication-table {\n      width: 100%;\n      min-width: 1165px;\n      display: grid;\n      grid-template-columns: 5.5fr 2fr 2fr 2fr 2.5fr;\n      grid-template-rows: auto;\n      grid-gap: 0;\n      font-size: 0.875rem;\n      &.alternate-medication-table-rows {\n        margin: 0 0.5rem;\n      }\n      > div {\n        padding: 0.5rem;\n        &.alternate-medication-table__header {\n          font-weight: 700;\n          font-size: 0.875rem;\n          border-bottom: 1px solid var(--grey-30);\n          border-right: 0;\n          border-left: 0;\n          padding: 1rem;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n  }\n  .view-more-alternate-medications {\n    margin: 1rem;\n    a {\n      color: var(--brand-50);\n      font-weight: 700;\n      font-size: 0.9rem;\n    }\n  }\n  .alternate-medication-mobile-view {\n    margin: 0 1rem 0.5rem 1rem;\n    border-top: 1px solid var(--neutral-40);\n    line-height: 2rem;\n    .title {\n      font-weight: 700;\n      padding: 1rem 0;\n    }\n    .alternate-medication-mobile-row {\n      background: var(--grey-20);\n      padding: 1rem 0.5rem;\n      &:nth-child(odd) {\n        background: var(--weight);\n      }\n      dl {\n        display: flex;\n        dt {\n          flex: 1;\n          font-weight: 700;\n        }\n        dd {\n          flex: 0.6;\n        }\n        ods-icon {\n            margin-top: 0.5rem;\n        }\n      }\n    }\n    \n    .view-more-alternate-medications {\n        margin: 0.5rem;\n        border-top: 1px solid var(--neutral-20);\n        border-bottom: 1px solid var(--neutral-20);\n        padding: 1rem 0;\n      }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
